import * as THREE from 'three'

// Check if device is mobile (touch device with coarse pointer)
const isMobile = () => {
  return window.matchMedia('(pointer: coarse)').matches ||
         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export class CameraController {
  constructor(sizes) {
    this.camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000)
    this.camera.position.z = 3
    
    // Mouse parallax
    this.cursor = { x: 0, y: 0 }
    this.parallaxStrength = 2
    
    // Disable parallax on mobile devices
    this.isMobile = isMobile()
    
    // Scroll offset (additive to parallax)
    this.scrollZ = 0
    
    if (!this.isMobile) {
      window.addEventListener('mousemove', this.onMouseMove.bind(this))
    }
  }
  
  onMouseMove(event) {
    this.cursor.x = (event.clientX / window.innerWidth) - 0.5
    this.cursor.y = (event.clientY / window.innerHeight) - 0.5
  }
  
  update(targetZ) {
    // Parallax effect (disabled on mobile)
    if (!this.isMobile) {
      const parallaxX = this.cursor.x * this.parallaxStrength
      const parallaxY = -this.cursor.y * this.parallaxStrength
      
      // Smoothly interpolate parallax position
      this.camera.position.x += (parallaxX - this.camera.position.x) * 0.05
      this.camera.position.y += (parallaxY - this.camera.position.y) * 0.05
    }
    
    // Always update Z position from scroll
    this.camera.position.z += (targetZ - this.camera.position.z) * 0.08
  }
  
  onResize(sizes) {
    this.camera.aspect = sizes.width / sizes.height
    this.camera.updateProjectionMatrix()
  }
  
  getCamera() {
    return this.camera
  }
}
